/* eslint-disable camelcase */
interface DisplayBulkFeatureGtmEvent {
  event: 'interaction_display bulk feature';
  e_category: 'navigation';
  e_action: 'Display bulk feature';
  amp_event_name: 'Display bulk feature';
  event_trigger: 'MM offer' | 'Seller offer';
  page_name: 'product';
  page_type: 'product';
  bulk_threshold: string;
  has_coupon: boolean;
}

export const GTM_DISPLAY_BULK_FEATURE = (
  index: number,
  hasCoupon: boolean,
): DisplayBulkFeatureGtmEvent => {
  const bulkThreshold =
    index !== -1 ? `threshold ${index + 1}` : 'No threshold';

  return {
    event: 'interaction_display bulk feature',
    e_category: 'navigation',
    e_action: 'Display bulk feature',
    amp_event_name: 'Display bulk feature',
    event_trigger: 'Seller offer',
    page_name: 'product',
    page_type: 'product',
    bulk_threshold: bulkThreshold,
    has_coupon: hasCoupon,
  };
};
